/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import * as stylex from '@stylexjs/stylex';
import type { HTMLAttributes } from 'react';
import { createContext, type ForwardedRef, forwardRef } from 'react';
import {
  type ContextValue,
  Provider,
  UNSTABLE_ToastContent as ToastContentCore,
  useContextProps,
} from 'react-aria-components';
import { CloseStrokeIcon } from '../../icons/close-stroke/close-stroke.icon';
import { dark } from '../../theme';
import { $ } from '../../tokens.stylex';
import { Button, BUTTON_SLOTS, ButtonContext, type ButtonProps } from '../button/button.component';
import { IconContext } from '../icon/icon.component';
import { Text, TextContext } from '../text/text.component';

interface TableSelectionSnackbarProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style' | 'className'> {
  selectedRowsCount: number | 'all';
  onClearSelection: ButtonProps['onPress'];
  style?: stylex.StyleXStyles;
}

const TableSelectionSnackbarContext = createContext<ContextValue<TableSelectionSnackbarProps, HTMLDivElement>>({});

const TableSelectionSnackbar = forwardRef((props: TableSelectionSnackbarProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, TableSelectionSnackbarContext);

  const { style, children, selectedRowsCount, onClearSelection, ...coreProps } = props;

  return (
    <ToastContentCore ref={ref} {...stylex.props(dark, styles.base, style)} {...coreProps}>
      <Provider
        values={[
          [
            TextContext,
            {
              size: 13,
              color: 'white',
            },
          ],
          [
            ButtonContext,
            {
              size: 32,
              variant: 'quaternary',
              style: { text: textStyles.base },
            },
          ],
          [
            IconContext,
            {
              color: 'quaternary',
            },
          ],
        ]}
      >
        <Button onPress={onClearSelection}>
          <Text>{selectedRowsCount === 'all' ? 'All' : selectedRowsCount} selected</Text>
          <CloseStrokeIcon slot={BUTTON_SLOTS.RIGHT} />
        </Button>
        {children}
      </Provider>
    </ToastContentCore>
  );
});

const styles = stylex.create({
  base: {
    padding: 8,
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    gap: 80,
    alignItems: 'center',
    backgroundColor: $.surfaceBlack,
    boxSizing: 'border-box',
    display: 'flex',
    flexShrink: 0,
    height: 48,
  },
});

const textStyles = stylex.create({
  base: {
    color: $.textWhite,
  },
});

export { TableSelectionSnackbar, TableSelectionSnackbarContext, type TableSelectionSnackbarProps };
